import { Button, Col, PaginationProps, Row, Space, Table, message } from 'antd';
import ModalCustom from 'components/common/ModalCustom/ModalCustom';
import ModalContent from 'pages/CommonCatalog/Nation/ModalContent/ModalContent';
import React, { useEffect, useRef, useState } from 'react'
import ModalEdit from './ModalEdit/ModalEdit';
import { ListActionButton } from 'components/common';
import { columns } from './ListSpecimen.config';
import {analysisService} from "api";
import Notification from 'components/common/notification/notification';

const ListSpecimen = () => {
  const modalRef = useRef<any>();
  const [type, setType] = useState("");
  const [record, setRecord] = useState(null);
  const [listDilate, setListDilate] = useState<any>();
  const [loading, setLoading] = useState(false);
  columns.find(e => e.dataIndex == "action").render = (
    value,
    _record,
    index
  ) => {
    return (
      <ListActionButton
        deleteFunction={() => {
          deleteDilate(_record.id);
          //   console.log("123");
        }}
        editFunction={() => {
          setType("Sửa");
          setRecord(_record);
          modalRef.current?.openModal();
        }}
      ></ListActionButton>
    );
  };

  useEffect(()=>{
    getList();
  },[])

  const getList = async () => {
    setLoading(true);
    try {
      const res = await analysisService.getListCategorySpecimen().then(res => {
        // console.log('res danh muc benh pham', res);
        setListDilate(res.data);
      });
      setLoading(false);
    } catch (error) {
      
      setLoading(false);
      Notification("error", "Đã có lỗi xảy ra khi lấy danh mục bệnh phẩm");
    }
  };

  const deleteDilate = async id => {
    try {
      const res = await analysisService.deleteCategorySpecimen(id);
      // message.success("Đã xóa dữ liệu vừa chọn");
      await getList();
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi xoá");
    }
  };

  const onChange: PaginationProps["onChange"] = (page, pageSize) => {
    getList();
  };


  return (
    <Space
      direction="vertical"
      className="Dilate container"
      style={{width: "100%"}}
    >
      <Row justify={"space-between"}>
        <Col>
          {" "}
          <div className="title">Danh mục loại bệnh phẩm</div>{" "}
        </Col>
        <Col>
          <Button
            type="primary"
            onClick={() => {
              setType("Thêm");
              setRecord(null);
              modalRef.current?.openModal();
            }}
          >
            Thêm mới
          </Button>
        </Col>
      </Row>
      <div className="container-table">
        <Table
          loading={loading}
          bordered
          columns={columns}
          pagination={{
            position: ["bottomRight"],
            showSizeChanger: true,
            onChange: onChange,
          }}
          dataSource={listDilate}
        ></Table>

        <ModalCustom
          ref={modalRef}
          width={1000}
          title={`${type} loại bệnh phẩm`}
        >
          <ModalEdit
            data={record}
            getListDilate={getList}
            type={type}
          ></ModalEdit>
        </ModalCustom>
      </div>
    </Space>
  )
}

export default ListSpecimen